(function ($) {
	$.fn.projectCard = function () {
		let $el;

		const init = function () {
			$el.find('.gallery').slick({
				dots: true,
				prevArrow: $el.find('.gallery__arrow--prev'),
				nextArrow: $el.find('.gallery__arrow--next'),
				cssEase: 'cubic-bezier(0.77,0,0.18,1)',
				speed: 500,
			});

			$el.on('mouseover', function () {
				if (
					$('[data-project-id="' + $(this).attr('id') + '"]').length >
					0
				) {
					$(
						'[data-project-id="' + $(this).attr('id') + '"]'
					).addClass('project-card-hover');
				}
			});

			$el.on('mouseleave', function () {
				if (
					$('[data-project-id="' + $(this).attr('id') + '"]').length >
					0
				) {
					$(
						'[data-project-id="' + $(this).attr('id') + '"]'
					).removeClass('project-card-hover');
				}
			});
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).projectCard();
				});
			} else {
				$el = this;
				init();
			}
		}
	};

	$(window).on('load', function () {
		$('.project-card').projectCard();
	});

	// Extra settings for projects__list which is a wrapper for project cards.
	let isTrackpad = false;
	window.addEventListener('mousewheel', detectTrackPad, false);
	window.addEventListener('DOMMouseScroll', detectTrackPad, false);
	function detectTrackPad(e) {
		if (e.wheelDeltaY) {
			if (e.wheelDeltaY === e.deltaY * -3) {
				isTrackpad = true;
			} else {
				isTrackpad = false;
			}
		} else if (e.deltaMode === 0) {
			isTrackpad = true;
		}
	}

	const scrollContainer = document.querySelector('.projects-slider__list');
	scrollContainer.addEventListener(
		'wheel',
		// eslint-disable-next-line no-unused-vars
		(e) => scrollLeftRight(scrollContainer, e),
		false
	);
	function scrollLeftRight(container, e) {
		if (false === isTrackpad) {
			e.preventDefault();
			container.scrollLeft += e.deltaY;
		}
	}

	// This is to keep the slider edge-to-edge but cut off the scrollbar.
	$(window).on('load resize', function () {
		const $list = $('.projects-slider__list');
		const listHeight = $list.height() + 8;
		$list.parent().height(listHeight);
	});
})(jQuery);
